import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import FavouriteSellersEmpty from './favourite-sellers-empty.svg?jsx';
import startPageStyles from '../start-page.module.scss';
import styles from './favourite-sellers.module.scss';

const FavouriteSellersFallback = ({ fromFavouriteSellersPage = false }) => {
    const { t } = useTranslator();

    return (
        <div
            className={`${
                fromFavouriteSellersPage
                    ? 'mr-2 ml-lg-1 mr-lg-3'
                    : 'mx-2 mx-md-3 mx-lg-2 mx-xl-1 mr-md-2'
            }  p-2 ${
                fromFavouriteSellersPage ? '' : startPageStyles.withArrowTop
            } bg-light d-flex flex-column align-items-center`}>
            <FavouriteSellersEmpty
                className={`${styles.fallbackImage} m-4 mb-3 mt-md-6 mb-md-5`}
            />
            <p className="mb-0 mb-md-2 text-styled text-center">
                {t('startPage_favoriteSeller_fallbackDescription')}
            </p>
        </div>
    );
};

export default FavouriteSellersFallback;
